import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ModalEntry = {
	state: boolean
	store: Record<string, unknown>
}

export interface ModalsState {
	modals: Record<string, ModalEntry>
}

const emptyEntry = (): ModalEntry => ({ state: false, store: {} })

const initialState: ModalsState = {
	modals: {},
}

export const modalsSlice = createSlice({
	name: 'modals',
	initialState,
	reducers: {
		ensureModal: (state, action: PayloadAction<string>) => {
			const id = action.payload
			if (!state.modals[id]) {
				state.modals[id] = emptyEntry()
			}
		},
		setModalState: (
			state,
			action: PayloadAction<{ id: string; state: boolean; store?: Record<string, unknown> }>
		) => {
			const { id, state: isOpen, store } = action.payload
			if (!state.modals[id]) {
				state.modals[id] = emptyEntry()
			}
			state.modals[id].state = isOpen
			if (store !== undefined) {
				state.modals[id].store = store
			}
		},
		setModalStoreProperty: (
			state,
			action: PayloadAction<{ id: string; key: string; value: unknown }>
		) => {
			const { id, key, value } = action.payload
			if (!state.modals[id]) {
				state.modals[id] = emptyEntry()
			}
			state.modals[id].store[key] = value
		},
	},
})

export const { ensureModal, setModalState, setModalStoreProperty } = modalsSlice.actions

export default modalsSlice.reducer
